import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	dropdown: {
		height: '32px',
		width: '200px',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.medium'),
	},
});

export const SnippetSortDropdownSkeleton = () => {
	return <Box xcss={styles.dropdown} />;
};
